import Autocomplete from "components/Autocomplete";
import React from "react";
import useText from "constants/text";

interface IMonthOptionReccurence {
  options: any[];
  option: any;
  setReccurenceOptionMonth: React.Dispatch<React.SetStateAction<any>>;
  error: boolean
}

export default function MonthOptionReccurence({
  options,
  option,
  setReccurenceOptionMonth,
  error
}: IMonthOptionReccurence) {
  const { text } = useText();

  const onChange = (option: any) => {
    setReccurenceOptionMonth(option);
  };

  return (
    <Autocomplete
      label="Occurence"
      options={options}
      getOptionLabel={(option: any) => options.find(o => o.value === option.value)?.description(text)}
      getOptionSelected={(option: any, selection: any) => option?.value === selection?.value}
      onChange={(event: any, value: any) => onChange(value)}
      value={option}
      error={error && !option}
    />
  );
}
